import { Autocomplete, TextField } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { YardPositionOption } from '../models/journey-position'

interface Props {
  value?: number
  label: string
  list: YardPositionOption[]
  hasError?: boolean
  dataCy?: string
  onChange: (selected?: number) => void
}
export const YardSelectorAutocomplete = observer(
  ({ value, label, list, hasError, dataCy, onChange }: Props) => {
    const { t } = useTranslate()

    return (
      <Autocomplete
        options={list}
        renderInput={params => (
          <TextField
            {...params}
            label={label}
            required
            error={hasError && !value}
            helperText={hasError && !value ? t('fieldIsRequired', 'Field is required') : undefined}
            data-cy={dataCy}
          />
        )}
        onChange={(e, value) => {
          onChange(value?.value)
        }}
        getOptionLabel={option => option.label}
        fullWidth
        value={list.find(y => y.value === value) ?? null}
      />
    )
  },
)
